import React from 'react';
import { twMerge } from 'tailwind-merge';

import getAssetSource from '../../../app/Search/utils/getAssetSource';
import { Text } from '../../../builder-io/storyblocks-design-system/components/atoms/Text/Text';
import { ProgressiveImage } from '../../../storywind';

interface SocialProofCardProps {
  name: string;
  image: string;
  type: 'logo' | 'creator';
  highlighted?: boolean;
  className?: string;
  alt?: string;
  logoBackgroundColor?: string;
}

const SocialProofCard = ({
  name,
  image,
  type,
  highlighted,
  className = '',
  alt,
  logoBackgroundColor,
}: SocialProofCardProps) => {
  const styledHeight = type !== 'logo' ? 'h-54 row-span-2' : 'h-20';
  const styledImage = type === 'logo' ? 'object-contain' : 'object-cover';
  const fontSize = highlighted ? '2xl' : 'base';
  const styledContainer = twMerge(
    className,
    'mb-4 lg:mb-8 min-w-24 border-0 rounded-xl relative overflow-hidden',
    !highlighted ? styledHeight : 'h-54 lg:h-185 lg:-mt-4',
    type === 'creator' && 'bg-gray-800'
  );
  return (
    <div
      className={styledContainer}
      style={
        type === 'logo' && logoBackgroundColor
          ? { backgroundColor: logoBackgroundColor }
          : undefined
      }
    >
      {image && (
        <ProgressiveImage
          className={`absolute inset-0 ${styledImage} w-full h-full`}
          src={getAssetSource(image)}
          alt={alt}
          shouldLazyLoad={true}
        />
      )}
      {type === 'creator' && (
        <Text
          fontSize={fontSize}
          fontFamily="polysans"
          className="absolute bottom-0 text-white w-full p-4"
        >
          <span>{name}</span>
        </Text>
      )}
    </div>
  );
};

export default SocialProofCard;
